import { getEventManager } from '../../utils/event-manager';

type PopupMessageEvent = 'showPopupMessage' | 'removePopupMessage';

export const eventManager = getEventManager<PopupMessageEvent>();
